import { ExistingSystemType } from 'data/types';

export type AnchorSystemType = 'ducted' | 'ptac';

export function anchorSystemTypeForPathway(args: {
  isDuctedPathway: boolean;
  isHybridPathway: boolean;
  isPtacPathway: boolean;
}): AnchorSystemType | null {
  if (args.isPtacPathway) return 'ptac';
  if (args.isDuctedPathway || args.isHybridPathway) return 'ducted';
  return null;
}

export function isStaleAnchorExistingSystem(
  existingSystems: ExistingSystemType[],
  anchorType: AnchorSystemType
): boolean {
  return (
    existingSystems.length === 1 &&
    existingSystems[0].components.length === 0 &&
    existingSystems[0].type !== anchorType
  );
}
